import { render, staticRenderFns } from "./heroHomepageContent.vue?vue&type=template&id=340d7334&"
import script from "./heroHomepageContent.vue?vue&type=script&lang=js&"
export * from "./heroHomepageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340d7334')) {
      api.createRecord('340d7334', component.options)
    } else {
      api.reload('340d7334', component.options)
    }
    module.hot.accept("./heroHomepageContent.vue?vue&type=template&id=340d7334&", function () {
      api.rerender('340d7334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/heroHomepage/heroHomepageContent.vue"
export default component.exports